import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface EntityTableProps {
    entities: any[];
    entityType: 'vc_firm' | 'angel_investor' | 'organization' | 'people_of_interest';
}

const EntityTable: React.FC<EntityTableProps> = ({ entities, entityType }) => {
    if (!entities.length) {
        return <Typography sx={{ mt: 3, mb: 3, textAlign: 'center' }}>No records found for this category.</Typography>;
    }
    return (
        <TableContainer component={Paper} sx={{ mb: 4 }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><b>Name</b></TableCell>
                        {entityType === 'vc_firm' || entityType === 'angel_investor' ? (
                            <>
                                <TableCell><b>Investment Focus</b></TableCell>
                                <TableCell><b>Website</b></TableCell>
                                <TableCell><b>Main HQ</b></TableCell>
                            </>
                        ) : entityType === 'organization' ? (
                            <>
                                <TableCell><b>Description</b></TableCell>
                                <TableCell><b>Industry</b></TableCell>
                                <TableCell><b>Operations in Israel</b></TableCell>                                
                                <TableCell><b>Type</b></TableCell>
                            </>
                        ) : entityType === 'people_of_interest' ? (
                            <>
                                <TableCell><b>Location</b></TableCell>
                                <TableCell><b>Military History</b></TableCell>
                            </>
                        ) : null}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {entities.map((entity) => (
                        <TableRow key={entity.id} hover>
                            <TableCell>
                                <MuiLink component={RouterLink} to={`/${getEntityDetailPath(entityType, entity.id)}`} underline="hover">
                                    {entity.name}
                                </MuiLink>
                            </TableCell>
                            {entityType === 'vc_firm' || entityType === 'angel_investor' ? (
                                <>
                                    <TableCell>{entity.investment_theme || entity.investmentTheme || ''}</TableCell>
                                    <TableCell>
                                        {entity.website ? (
                                            <MuiLink href={entity.website} target="_blank" rel="noopener noreferrer" underline="hover">
                                                {entity.website}
                                            </MuiLink>
                                        ) : null}
                                    </TableCell>
                                    <TableCell>{entity.main_hq || entity.mainHQ || ''}</TableCell>
                                </>
                            ) : entityType === 'organization' ? (
                                <>
                                    <TableCell>{entity.description || ''}</TableCell>
                                    <TableCell>{entity.industries || ''}</TableCell>                                    
                                    <TableCell>{entity.has_operations_in_israel || entity.hasOperationsInIsrael ? 'Yes' : 'No'}</TableCell>
                                    <TableCell>
                                        {entity.org_type
                                            ? entity.org_type.charAt(0).toUpperCase() + entity.org_type.slice(1)
                                            : entity.orgType
                                                ? entity.orgType.charAt(0).toUpperCase() + entity.orgType.slice(1)
                                                : ''}
                                    </TableCell>
                                </>
                            ) : entityType === 'people_of_interest' ? (
                                <>
                                    <TableCell>{entity.location || ''}</TableCell>
                                    <TableCell>{entity.history_in_IDF || entity.historyInIDF || ''}</TableCell>
                                </>
                            ) : null}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

// Helper to get the correct detail path for each entity type
function getEntityDetailPath(entityType: string, id: string | number) {
    if (entityType === 'vc_firm') return `vc/${id}`;
    if (entityType === 'angel_investor') return `angel/${id}`;
    if (entityType === 'organization') return `organization/${id}`;
    if (entityType === 'people_of_interest') return `poi/${id}`;
    return `${entityType}/${id}`;
}

export default EntityTable;
